var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-smile-1707192",
    d: "M262.87,252.38a10.5,10.5,0,1,0,10.5,10.5A10.511,10.511,0,0,0,262.87,252.38Zm0,1.37a9.131,9.131,0,1,1-9.131,9.131A9.121,9.121,0,0,1,262.87,253.75Zm-3.88,4.794a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,258.99,258.543Zm7.761,0a1.6,1.6,0,1,0,1.6,1.6A1.6,1.6,0,0,0,266.751,258.543Zm-10.729,4.109a.737.737,0,0,0-.685.728,7.551,7.551,0,0,0,15.066,0,.713.713,0,0,0-.685-.728Zm.806,1.37h12.084a6.146,6.146,0,0,1-12.084,0Z",
    transform: "translate(-252.37 -252.38)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.724c27da1f20d662e72425947a562289.svg";
export { ForwardRef as ReactComponent };